export default __webpack_public_path__ + "static/media/wa-1719-1.da50c1eb.jpg";